import { CALENDAR_VIEWS } from "../const";

/**
 * Builds a minimal FullCalendar-style `arg` object so calendar UI components
 * (e.g. SingleEventCard) can render outside the calendar surface.
 */
export const buildCalendarEventArg = (event: Record<string, unknown>, viewType: string = CALENDAR_VIEWS.DAY) => {
  const startRaw = event.start;
  const start = startRaw instanceof Date ? startRaw : new Date(startRaw as string | number);
  const endRaw = event.end ?? event.start;
  const end = endRaw instanceof Date ? endRaw : new Date(endRaw as string | number);

  return {
    view: { type: viewType },
    event: {
      id: String(event.id ?? ""),
      title: (event.title as string) ?? "",
      start,
      end,
      startStr: start.toISOString(),
      endStr: end.toISOString(),
      extendedProps: (event.extendedProps as Record<string, unknown>) ?? {},
    },
  };
};
